(function(angular) {
    'use strict';
    angular.module('maideasy.booking', [

        'ui.router',
        'maideasy.directive',
        'maideasy.services',
        'maideasy.filter',
        'ngAutocomplete'

        ])

        .constant('SERVER_CONFIG', {

            live_path: 'https://core.maideasy.my',

            //live_path: 'localhost:8080',
        })

        .config(function($stateProvider,$urlRouterProvider) {

            $urlRouterProvider.otherwise('/start');

            $stateProvider
                .state('start', {
                    url:"/start",
                    templateUrl: "/maideasyPro/templates/start/index.html",
                    controller: "bookingController"
                })
                .state('status', {
                    url:"/status",
                    templateUrl: "/maideasyPro/templates/status/index.html",
                    controller: "statusController"
                })
                .state('token', {
                    url:"/start/:token",
                    templateUrl: "/maideasyPro/templates/start/index.html",
                    controller: "bookingController"
                })
        })

        .controller('appController',function($scope,$location){

            $scope.logout = function(){
                delete window.localStorage['profile']; 
                delete window.localStorage['secret']; 
                delete window.localStorage['token'];

                window.location.href = "/";
            }

        })

        .controller('navbarController', function($scope){

            $scope.goHomePage = function(){

                window.location.href = "/";
                
            }

            $scope.logout = function(){
                delete window.localStorage['secret'];
                window.location.href = "/";
            }
            
        })

        .controller('bookingController', function($scope,$http,$timeout,$location,$httpExtended,recurringService,$stateParams,$state,AuthenticationService) {
            

            $scope.recurring = [];

            $scope.auth = AuthenticationService.isLogged;

            $scope.placesResult = "";
            $scope.placesResultDetails = {}

            // watch address changes
            $scope.$watch('recurring.placesResultDetails', function () {
                try {
                    console.log($scope.recurring.placesResultDetails);
                    var locality = $scope.recurring.placesResultDetails.adr_address.match(/<span class="locality">(.*?)<\/span>/)
                    $scope.recurring.city = locality[1];
                    console.log($scope.recurring.city);

                    var state = $scope.recurring.placesResultDetails.adr_address.match(/<span class="region">(.*?)<\/span>/)
                    $scope.recurring.state = state[1];
                    console.log($scope.recurring.state);
                    $scope.checkAvailableLocation();
                } catch(e) {

                }
            }); 

           $scope.checkAvailableLocation = function(){
                $scope.error = "";

                switch($scope.recurring.state)
                {
                    case "Selangor":
                        break;
                    case "Negeri Sembilan":
                        break;    
                    case "Johor":
                        break;
                    case "Federal Territory of Kuala Lumpur":
                        $scope.recurring.state = "Kuala Lumpur";

                        break;
                    default:
                        $scope.error = "Sorry, right now we only cover Selangor, Kuala Lumpur, Johor Bahru and Negeri Sembilan";
                        $scope.errorMessage();
                        break;              
                }
            };

            $scope.errorMessage = function(){
                
                $scope.recurring.placesResultDetails = "";
                $scope.placesResult = "";
            }

            //init default data
            $scope.init = function(){

                $scope.token = $stateParams.token;

                if($scope.token != null)
                {
                    $http.get('/user/' + $scope.token)
                    .success(function(data){
                        $scope.prefillData(data);
                    })
                    .error(function(){
                        console.log("eror");
                    })
                }

                $scope.recurring.freq = "weekly";
                $scope.recurring.discount = 0;
                $scope.requests = 0;
                //$scope.recurring.time = "09:00:00";
                $scope.selectedTime = "";
                

                $scope.times = [];

                for(var x = 0 ; x < 12 ; x++){

                    var v = moment('2013-02-08 09:00:00.000').add(x,'hours').format('HH:mm:SS');
                    var d = moment('2013-02-08 09:00:00.000').add(x,'hours').format('hh:mm a');

                    if(x == 9 || x == 10 || x == 11)
                    {
                        d = d + " (2 hours session)";
                    }
                    $scope.times.push({value:v,name:d});
                }

                $scope.braintreeMessage = 'Book Now';

                $scope.dates = [];              

                for(var i = 1 ; i < 14 ; i++)
                {  
                    var d = moment().add(i,'days').format("dddd, MMMM DD");
                    var v = moment().add(i,'days').format("YYYY-MM-DD");
                    if(i == 0){
                        d = d + " (Today)";
                    }
                    else if(i == 1){
                        d = d + " (Tomorrow)";
                    } 

                    $scope.dates.push({value:v, name:d});
                }

                //$scope.recurring.date = moment().add(1,'days').format("YYYY-MM-DD");

                //$scope.updatePricing();
            }

            $scope.selectFreq = function(freq){
                $scope.recurring.freq = freq;
                $scope.updatePricing();
                $scope.updateTimes();
                $scope.updateDates();
            }

            $scope.toggleRequest = function(req){
                
                if(req.checked == false){
                    if( $scope.requests == 2){
                         return;
                    }else{
                        req.checked = true;
                        $scope.requests++;
                    }
                }else{
                    req.checked = false;
                    $scope.requests--;
                }

                return;
            }

            // get the location list
            $http({
                method: 'GET',
                url: '/api/bookings/locations'
            }).then(function successCallback(response) {
                $scope.locations = response.data;
            }, function errorCallback(response) {});


            $scope.updatePricing = function(){
                
                if(!$scope.recurring.time)
                {
                    $scope.recurring.time = "09:00:00";
                }
                
                $scope.selectedTime = "2017-01-01 " + $scope.recurring.time;

                if($scope.recurring.freq == "once")
                {   
                     if($scope.recurring.time == "18:00:00" || $scope.recurring.time == "19:00:00" || $scope.recurring.time == "20:00:00")
                    {
                        //clear nextday and weekend
                        $scope.clear();
                        $scope.isNight = true;
                        $scope.recurring.order_total = 50;
                        $scope.recurring.gst = $scope.recurring.order_total * 0.06;
                        $scope.recurring.discount = 0;
                        $scope.recurring.hours_booked = 2;
                    }
                    else
                    {
                        //clear nextday and weekend
                        $scope.clear();
                        $scope.isNight = false;

                        $scope.recurring.order_total = 100;
                        $scope.recurring.discount = 0;
                        $scope.recurring.total = $scope.recurring.order_total - $scope.recurring.discount;
                        $scope.recurring.gst = $scope.recurring.total * 0.06;
                        $scope.recurring.hours_booked = 4;

                        var day = moment($scope.recurring.date).isoWeekday();
                        var today = moment();
                        var todayFormated = moment().format('YYYY-MM-DD');
                        var diff = moment($scope.recurring.date).diff(today,'hours');
                        var same = moment($scope.recurring.date).isSame(todayFormated);

                        if(day == 6 || day == 7)
                        {
                            $scope.isNight = false;
                            $scope.isWeekend = true;
                            $scope.perhour = 22;
                            $scope.recurring.order_total = 100;
                            $scope.recurring.total = $scope.recurring.order_total - $scope.recurring.discount;
                            $scope.recurring.gst = $scope.recurring.total * 0.06;
                        }                        

                        //same day or next day
                        if(diff < 24)
                        {
                            $scope.clear();
                            $scope.isNight = false;
                            $scope.nextDay = true;
                            $scope.recurring.order_total = 100;
                            $scope.recurring.total = $scope.recurring.order_total - $scope.recurring.discount;
                            $scope.recurring.gst = $scope.recurring.total * 0.06;
                        } 
                    }                    
                // weekly recurring    
                }else{

                    if($scope.recurring.time == "18:00:00" || $scope.recurring.time == "19:00:00" || $scope.recurring.time == "20:00:00")
                    {
                        //clear nextday and weekend
                        $scope.clear();
                        $scope.isNight = true;
                        $scope.recurring.order_total = 50;
                        $scope.recurring.gst = $scope.recurring.order_total * 0.06;
                        $scope.recurring.discount = 0;
                        $scope.recurring.hours_booked = 2;
                    }else{

                        //clear nextday and weekend
                        $scope.clear();
                        $scope.isNight = false;
                        $scope.perhour = 25;
                        $scope.recurring.order_total = 100;
                        $scope.recurring.discount = 0;
                        $scope.recurring.total = $scope.recurring.order_total - $scope.recurring.discount;
                        $scope.recurring.gst = $scope.recurring.total * 0.06;
                        $scope.recurring.hours_booked = 4;
                        $scope.weekend = "";

                        var day = moment($scope.recurring.date).isoWeekday();
                        var today = moment();
                        var todayFormated = moment().format('YYYY-MM-DD');
                        var diff = moment($scope.recurring.date).diff(today,'hours');

                        if(day == 6 || day == 7)
                        {
                            $scope.isWeekend = true;
                            $scope.perhour = 25;
                            $scope.recurring.order_total = 100;
                            $scope.recurring.discount = 0;
                            $scope.recurring.total = $scope.recurring.order_total - $scope.recurring.discount;
                            $scope.recurring.gst = $scope.recurring.total * 0.06;
                        }

                        console.log(diff);

                        if(diff != 0 && diff < 24)
                        {
                            $scope.clear();
                            $scope.isNight = false;
                            $scope.nextDay = true;
                            $scope.recurring.order_total = 100;
                            $scope.recurring.total = $scope.recurring.order_total - $scope.recurring.discount;
                            $scope.recurring.gst = $scope.recurring.total * 0.06;
                        } 
                    }
                }                
            };

            $scope.updateTimes = function(){

                if($scope.recurring.freq != 'once')
                {
                    $scope.times = [];
                    

                    for(var x = 0 ; x < 12 ; x++){
                        var v = moment('2013-02-08 09:00:00.000').add(x,'hours').format('HH:mm:SS');
                        var d = moment('2013-02-08 09:00:00.000').add(x,'hours').format('hh:mm a');

                        if(x == 9 || x == 10 || x == 11)
                        {
                            d = d + " (2 hours only)";
                        }
                        $scope.times.push({value:v,name:d});
                    } 

                }else{
                    $scope.times = [];
                    $scope.times = [{value:"09:00:00",name:"09:00am ( 4 hours session )"},{value:"14:00:00",name:"02:00pm ( 4 hours session )"},{value:"20:00:00",name:"08:00pm ( 2 hours session )"}];
                }
                $scope.recurring.time = "09:00:00";
                $scope.selectedTime = "2017-01-01 " + $scope.recurring.time;
            };

            $scope.updateDates = function(){
                if($scope.recurring.freq == 'once')
                {
                    $scope.dates = [{value:"",name:""}]; 

                    for(var i = 0 ; i < 14 ; i++)
                    {  
                        var d = moment().add(i,'days').format("dddd, MMMM DD");
                        var v = moment().add(i,'days').format("YYYY-MM-DD");
                        if(i == 0){
                            d = d + " (Today)";
                        }
                        else if(i == 1){
                            d = d + " (Tomorrow)";
                        } 

                        $scope.dates.push({value:v, name:d});
                    }

                    $scope.recurring.date = moment().add(0,'days').format("YYYY-MM-DD");

                }else{

                    $scope.dates = [];
                    for(var i = 1 ; i < 14 ; i++)
                    {  
                        var d = moment().add(i,'days').format("dddd, MMMM DD");
                        var v = moment().add(i,'days').format("YYYY-MM-DD");

                        if(i == 1){
                            d = d + " (Tomorrow)";
                        } 

                        $scope.dates.push({value:v, name:d});
                    }

                    $scope.recurring.date = "";
                }
            }

            $scope.clear = function()
            {
                $scope.isWeekend = false;
                $scope.nextDay = false;
            };

            //braintree
            $timeout(function () {
                  braintree.setup(window.clientToken, "dropin", {
                        container: "dropin-container",
                        paymentMethodNonceReceived: function(event, nonce) {
                            
                            if($scope.validationErrors.length > 0){
                                $scope.braintreeMessage = "Use this card";
                                $('#cardSubmit').prop('disabled', false); // enable submit button
                                return;
                            }

                            $scope.recurring.payment_method_nonce = nonce;

                            $scope.braintreeMessage = 'PROCESSING';
                            $('#cardSubmit').prop('disabled', true); // disable submit button

                            var payurl = '/book/recurring';
                            console.log($scope.recurring);

                            recurringService.setRecurring($scope.recurring);

                            $httpExtended.post(payurl,$scope.recurring)
                                .then(function(data, status) {
                                    console.log(data);
                                    // return payment_status
                                    if (data.data.success) {
                                        
                                        $scope.recurring.payment_status = 'paid';
                                        if(data.data.secret != 'old_customer')
                                        {
                                            window.localStorage['secret'] = data.data.secret;
                                            window.location.href = "/user#/bookings";
                                        }else{
                                            $location.path("/status");
                                        }
                                        
                                        
                                        // $state.go('status');

                                    } else {

                                        $scope.recurring.payment_status = 'failed';
                                        $scope.braintreeMessage = 'UNSUCCESSFUL. TRY AGAIN';
                                        $('#cardSubmit').prop('disabled', false); // enable submit button
                                    }

                                }
                            );
                                
                        },
                        onReady: function() {
                            console.log('Braintree is ready');
                            // $rootScope.resizeSidebar();
                            $('#cardSubmit').prop('disabled', false); // enable submit button
                        }

                    });
                }, 500);            

            $scope.submitForm = function(){
                // check to make sure the form is completely valid
                $scope.bookingSubmitted = true;
                $scope.validate();

            }

            $scope.validate = function() {
                $scope.validationErrors = [];

                $timeout(function() {
                    angular.forEach(angular.element('.help-block'), function(element) {
                        if (!angular.element(element).hasClass('hidden')) {
                            $scope.validationErrors = $scope.validationErrors.concat(angular.element(element).text())
                        }
                    });
                }, 100);
            }

            $scope.prefillData = function(data){

                $scope.data = data.booking;

                console.log(data);

                if($scope.data.date != null)
                {
                    var date = $scope.data.date.split(" ");
                    $scope.recurring.date = date[0];
                    $scope.recurring.time = date[1];
                }

                $http.get('/location/'+$scope.data.city)
                .success(function(data){
                    $scope.recurring.location_id = data.id;
                })

                $scope.recurring = data.booking;


                //set to default
                $scope.recurring.date = moment().add(1,'days').format("YYYY-MM-DD");
                $scope.recurring.time = "09:00:00";
                $scope.updatePricing();
            }

            // track all booking changes to submit incompleted.
            $scope.change = function(){

                if($scope.recurring.name != null && $scope.recurring.mobile != null 
                    && $scope.recurring.email != null && $scope.recurring.address_1 != null
                    && $scope.recurring.address_2 != null && $scope.recurring.postcode != null 
                    && $scope.recurring.location_id != null)
                {
                    console.log("post to incompleted");
                    $scope.recurring.event_type = 'start_recurring';

                    $http.post('/book/event',$scope.recurring)
                    .then(function(data){
                        console.log("data receive");
                    })
                }
            }

            //init default data
            $scope.init();

            // $scope.updateCreditCard = function(){
            //     $scope.creditCardsShow = false;
            // }

            // $scope.cancelUpdate = function(){
            //     $scope.creditCardsShow = true;

            // }

            // submit for old customer
            $scope.submitRecurringForm = function(){


                var payurl = '/book/recurring';
                console.log($scope.recurring);

                recurringService.setRecurring($scope.recurring);

                $httpExtended.post(payurl,$scope.recurring)
                    .then(function(data, status) {
                        console.log(data);
                        // return payment_status
                        if (data.data.success) {
                            $scope.recurring.payment_status = 'paid';
                            $scope.recurring.customerId = data.data.customer_id;
                            $scope.next();
                        } else {
                            $scope.recurring.payment_status = 'failed';
                            $scope.braintreeMessage = 'UNSUCCESSFUL. TRY AGAIN';
                            $('#cardSubmit').prop('disabled', false); // enable submit button
                        }

                    }
                );

            }

        })

        .controller('bookingTokenController',function($scope,$stateParams,$http){

            $scope.token = $stateParams.token;
            // retrive booking from the server
            $http.get('/api/bookings/book/status/' + $scope.token)
            .success(function(){
                $scope.recurring;
            })
            .error(function(){

            })
        })

        .controller('statusController', function($stateParams,$scope,recurringService){
            
            // $scope.customerId = $stateParams.customerId;

            $scope.recurring=recurringService.getRecurring();

            console.log('$scope.recurring',$scope.recurring);
        
        })
        

        ;

})(window.angular);
//# sourceMappingURL=app.js.map
